<template>
  <div id="app" :class="containerClasses">
    <header id="top-header">
      <nav class="inner">
        <h1 id="site-logo"><router-link v-bind:to="'/home'"><span class="alt-text">{{siteName}}</span></router-link></h1>
        <ul class="menu horizontal">
          <li v-for="(item,index) in menu" :class="'item-' + index" @click="listen(item)"><router-link v-bind:to="item.link">{{item.title}}</router-link></li>
        </ul>
        <div v-if="isProjectPage" class="project-arrow icon-triangle-next" @click="showNext()"></div>
      </nav>
      <div class="menu-toggle icon-hamburger" v-on:click="menuToggle()"><span class="label">{{menu_toggle_label}}</span></div>
    </header>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <footer id="footer">
      <ul class="bottom-list horizontal menu">
        <li class="copyright" v-on:click="clearCaches()">{{footer.copyright}}</li>
        <li v-for="item in footer.menu"><router-link v-bind:to="item.link">{{item.title}}</router-link></li>
        <li class="email" v-if="footer.email.length > 5"><a :href="'mailto:' + footer.email">{{footer.email}}</a></li>
      </ul>
      <div v-if="statusMsg.length > 1" class="status-msg" :class="{'show':showStatusMsg}">{{statusMsg}}</div>
    </footer>
    <div class="loader"></div>
    <div v-if="isAdmin" id="admin-bar"><span v-if="currId > 0" v-on:click="showAdminOverlay()" v-on:dblclick="showAdminPage()">Edit</span></div>
    <div v-if="isAdmin" class="overlay-container" :class="{'show-admin': showAdmin}">
      <div v-show="showAdmin" class="close" v-on:click="hideAdminOverlay()">x</div>
      <iframe :src="adminUrl" id="admin-frame" name="admin-frame"></iframe>
    </div>
  </div>
</template>
<script>

function scrollY () {
  if (window.pageYOffset) { return window.pageYOffset }
  return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
}

function winWidth () {
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth
  }
  if (document.body) {
    return document.body.clientWidth
  }
}

function isTouchDevice () {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener("test", null, opts);
} catch (e) {}

var passiveProps = supportsPassive? {passive: true} : false


export default {
  name: 'app',
  data: function() {
    return {
      loading: false,
      alias: 'home',
      section: 'main',
      infoLoaded: false,
      touchEnabled: false,
      touchActive: false,
      nodes: [],
      menu: [],
      menu_toggle_label: 'Menu',
      owner: '',
      content: {},
      hasContent: false,
      siteName: 'Blustin Design',
      strapline: '',
      title: 'Welcome',
      isAdmin: false,
      adminUrl: "",
      currId: 0,
      showAdmin: false,
      backend: 'https://www.blustindesign.com/',
      mediabase: 'https://www.blustindesign.com/',
      containerClasses: [],
      statusMsg: '',
      showStatusMsg: false,
      footer: {
        copyright: '© 2018 Blustin Design',
        menu: [
          {link:'/terms','title':'Terms & conditions'}
        ],
        email: '',
      },
      fullSizes: {
        'max_1600x1600': '(min-width:1301px)',
        'max_1300x1300': '(min-width:641px) and (max-width:1300px)',
        'max_720x720': '(max-width:640px)'
      },
      fixedSizes: {
        'scalecrop_1600_720': '(min-width:1441px)',
        'scalecrop_1440_648': '(min-width:1025px) and (max-width:1440px)',
        'scale_crop_1024_461': '(min-width:641px) and (max-width:1024px)',
        'scalecrop_720_960': '(max-width:640px) and (min-height:401px)',
        'scalecrop_720_324': '(max-width:640px) and (max-height:400px)'
      },
      landscapeFixedSizes: {
        'scalecrop_1024_742': '(min-width:1201px)',
        'scalecrop_640_464': '(max-width:1200px)'
      },
      portraitFixedSizes: {
        'scalecrop_720_960': '(min-width:0px)',
      },
      preloadedImgs: [],
      previewWidth: 640,
      stopY: 0,
      prevY: 0,
      pageHeight: 0,
      winHeight: 0,
      winWidth: 0,
      scrolling: false,
      allProjectsLoaded: false,
      isProjectPage: false
    }
  },
  created: function () {
    if (process.env) {
      if (process.env.BACKEND) {
        this.backend = process.env.BACKEND,
        this.mediabase = process.env.MEDIABASE
      }
    }
    this.addContainerClass('loading')
    this.touchEnabled = isTouchDevice()
    if (this.touchEnabled) {
      this.addContainerClass('touch-enabled')
    }
    this.checkSiteInfo()
    this.checkLoggedin()
    this.handleResize(true)
    
    window.addEventListener('keydown', this.handleKeys)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll, passiveProps)
  },
  watch: {
    showAdmin: function() {
      if (this.showAdmin) {
        this.addContainerClass('has-overlay')
      } else {
        this.removeContainerClass('has-overlay')
      }
    },
    '$route.path': function () {
      this.updatePage()
    }
  },
  methods: {
    updatePage: function(init) {
      if (init !== true && this.section !== 'journal') {
        this.addContainerClass('loading')
      }
      this.removeContainerClass('show-menu')
      this.matchAlias()
      var loadingTs = 2000
      switch (this.section) {
        case 'home':
          loadingTs = 4000
          break;
        case 'projects':
          if (this.alias != 'projects') {
            this.$emit('show-project', {path:'/' + this.alias})
          } else {
            loadingTs = 3000
          }
          break;
        case 'journal':
          loadingTs = 2000
          break;
        default:
          this.loadPage()
          break;
      }
      var comp = this 
      setTimeout(function () {
        comp.removeContainerClass('loading')
        comp.updateTitle()
      }, loadingTs);
    },
    listen: function(item) {
      switch (item.link) {
        case '/projects':
          window.location.hash = '#all'
          break;
      }
    },
    updateTitle: function() {
      var el = document.querySelectorAll('h2')
        switch (this.alias) {
          case 'projects':
            el =  document.querySelectorAll('.projects h2.content-title')
            break;
        }
        if (el.length > 0) {
          this.title = el[0].textContent
        }
        document.title = this.title + ': ' + this.siteName
    },
    matchAlias: function () {
      var path = this.$route.path
      var alias = path.replace(/^\//, '')
      if (alias.length < 2) {
        alias = 'home';
      }
      this.alias = alias;
      this.section = alias.split('/').shift();
      this.isProjectPage = this.section == 'projects' && this.alias != 'projects'
    },
    loadPage: function () {
      if (this.alias.length > 1 && this.loading !== true) {
        var alias = this.alias
        var comp = this
        var index = _.findIndex(this.nodes, function (n) {
          return n.alias.replace(/^\//,'') === alias
        })
        if (index >= 0) {
          this.loading = true
          var node = this.nodes[index]
          var refName = 'node-full/' + node.nid
          var reload = this.matchEdited(node) >= 0
          this.loadData(refName, function(data) {
            comp.addArticle(data)
            comp.updateTitle()
          }, 'jsonstyles', reload)
        } else {
          setTimeout(function () {
            comp.addNotFound()
          }, 3000)
        }
      }
    },
    matchEdited: function (node) {
      var edited = this.$ls.get('editednodes')
      if (edited) {
        if (edited.total) {
          if (edited.total > 0) {
            return _.findIndex(edited.nodes, function (n) {
              return parseInt(n.nid) === parseInt(node.nid) && parseInt(n.changed) > parseInt(node.changed)
            })
          }
        }
      }
      return -1
    },
    addNotFound: function () {
      if (!this.hasContent) {
        this.title = 'Page not found'
        this.content.body = 'This resource is not available'
        this.content.hasImage = false
        this.hasContent = true
        this.showTitle = true
      }
    },
    addArticle: function (data, refName) {
      if (data.title) {
        this.currId = data.nid
        this.content = data
        this.title = data.title
        this.hasContent = true
        this.content.hasImage = false
        this.showTitle = false
        if (data.image) {
          if (data.image instanceof Object && data.image !== null) {
            this.content.hasImage = data.image.hasOwnProperty('sizes')
          }
        }
        this.$emit('node-update')
      }
      var comp = this
      setTimeout(function () {
        comp.loading = false
      }, 250)
    },
    editNode: function (id) {
      this.adminUrl = this.backend + 'node/' + id + '/edit'
      var comp = this
      setTimeout(function () {
        comp.showAdmin = true
      }, 500)
    },
    showAdminOverlay: function() {
      if (this.currId > 0) {
        this.editNode(this.currId)
      }
    },
    showAdminPage: function() {
      if (this.currId > 0) {
        window.open(this.adminUrl, "_BLANK")
      }
    },
    hideAdminOverlay: function () {
      this.showAdmin = false
    },
    checkLoggedin: function () {
      var comp = this
      var ts = new Date().getTime()
      this.$http.get(this.backend + '/jsonstyles/user?ts=' + ts)
      .then(function (response) {
        if (response.data) {
          if (typeof comp === 'object') {
            comp.user = response.data
            if (comp.user.roles) {
              comp.isAdmin = comp.user.is_editor
            }
          }
        }
      }, function (response) {})
    },
    loadData: function(path, callback, prefix, reload) {
      if (!prefix) {
        prefix = 'jsonstyles'
      }
      var cacheKey = path.replace(/\//g,'_')
      var data = this.$ls.get(cacheKey, null)

      var hasCallback = (typeof callback === 'function')
      var comp = this
      if (reload !== true && (data instanceof Array || (data instanceof Object && data.valid))) {
        if (hasCallback) {
          callback(data)
        }
      } else {
        var matched = false;
        if (hasCallback) {
          var preload_item = '';
          switch (path) {
            case 'home':
              preload_item = 'home_slides';
              break;
            case 'projects-full':
              preload_item = 'top_projects';
              break;
            default:
              preload_item = path.replace('-','_').replace('/','__');
              break;
          }
          if (preload_item.length > 0) {
            if ($preload.hasOwnProperty(preload_item)) {
              if ($preload[preload_item] !== null && $preload[preload_item] instanceof Object) {
                matched = true
                callback($preload[preload_item]);
              }
            }
          }
        }
        if (!matched) {
          var qstr = '?r=' + (10 * Math.random()).toFixed(6)
          this.$http.get(this.backend + prefix + '/' + path + qstr).then(function (response) {
            if (response.data instanceof Array|| (response.data instanceof Object && response.data.valid)) {
              comp.$ls.set(cacheKey, response.data, (24 * 60 * 60 * 1000))
              if (hasCallback) {
                callback(response.data)
              }
             if (response.data.nid) {
               comp.updateSiteInfoNode(response.data)
             } else if (response.data.items) {
                if (response.data.items instanceof Array) {
                  for (var i = 0; i < response.data.items.length; i++) {
                    if (response.data.items[i].nid) {
                      comp.updateSiteInfoNode(response.data.items[i]);
                    }
                  }
                }
             }
            }
          }, function (response) {})
        }
      }
    },
    updateSiteInfoNode: function(node) {
      var d = this.$ls.get('sitedata', null), pi = -1
      if (d) {
        if (d.nodes) {
          pi = _.findIndex(d.nodes, function(n) { return n.nid == node.nid; })
        }
      }
      if (node.changed && pi >= 0) {
        d.nodes[pi].changed = node.changed
        this.$ls.set('sitedata', d)
      }
    },
    getNode: function (nid) {
      this.loadData('node-full/' + nid);
    },
    checkSiteInfo: function () {
      var data = this.$ls.get('sitedata', null)
      var ts = new Date().getTime()
      var prevTs = this.$ls.get('ts')
      if (data !== null) {
        this.loadSiteInfo(data)
      } else {
        var matched = false
        if ($preload) {
          if ($preload.site_info) {
            if ($preload.site_info.menu) {
              if ($preload.site_info.menu instanceof Array) {
                matched = true
                this.loadSiteInfo($preload.site_info);
              }
            }
          }
        }
        if (!matched) {
           this.fetchSiteInfo(ts)
        }
      }
      if ((ts - prevTs) > (15 * 60 * 1000)) {
        var comp = this
        setTimeout(function () {
          comp.fetchSiteInfo(ts)
        }, 5000)
      }
    },
    fetchSiteInfo: function (ts) {
      var comp = this
      this.$http.get(this.backend + 'jsonstyles/siteinfo')
      .then(function (response) {
        if (response.data) {
          if (typeof response.data === 'object') {
            comp.loadSiteInfo(response.data)
            comp.$ls.set('sitedata', response.data, (7 * 24 * 60 * 60 * 1000))
            comp.$ls.set('ts', ts)
          }
        }
      }, function (response) {})
    },
    loadSiteInfo: function (data) {
      if (data.site_name) {
        this.siteName = data.site_name
      }
      if (data.menu) {
        this.menu = data.menu
      }
      if (data.footer) {
        if (data.footer.copyright) {
          this.footer.copyright = data.footer.copyright
        }
        if (data.footer.menu) {
          if (data.footer.menu instanceof Array) {
            this.footer.menu = data.footer.menu
          }
        }
        this.footer.email = ''
        if (data.footer.email) {
          if (typeof data.footer.email === 'string' && data.footer.email.length > 5) {
            this.footer.email = data.footer.email
          }
        }
      }
      if (data.owner) {
        this.owner = data.owner
      }
      if (data.strapline) {
        this.strapline = data.strapline
      }
      if (data.nodes && data.nodes instanceof Array) {
        this.nodes = data.nodes
        this.infoLoaded = true
        this.updatePage(true)
      }
      var comp = this
      if (this.section !== 'home') {
        setTimeout(function () {
          comp.loadData('home');
        }, 1500);
      }
      
      var checkEditedTs = this.section !== 'home'? 2250 : 8000;

       setTimeout(function () {
          comp.checkEdited(true);
        }, 2250);

      if (this.section !== 'projects' && !this.allProjectsLoaded) {
        setTimeout(function () {
          comp.loadData('projects-full');
        }, 3000);
      }
      if (this.section !== 'journal') {
        setTimeout(function () {
          comp.loadData('journals');
        }, 5000);
      }
      setTimeout(function () {
          var otherNodes = _.filter(comp.nodes, function (n) {
            return n.alias !== '/' + comp.alias && n.alias.split('/').length < 3
          })
          if (otherNodes.length > 0) {
            for (var i = 0; i < otherNodes.length; i++) {
              comp.getNode(otherNodes[i].nid, null, true)
            }
          }
        }, 4000)
    },
    preloadImg: function(imgSizes,addPreview) {
      var keys = Object.keys(imgSizes),
        i = 0,
        j = 0,
        len = keys.length,
        include = false,
        imgs = [],
        k,p, m, w;
      for (; i < len; i++) {
        k = keys[i]
        m = k.match(/_(\d+)[_x](\d+)/);
        if (m) {
          w = parseInt(m[1]);
          include = w > this.winWidth && w < (this.maxWidth * 1.667);
          if (!include && addPreview === true) {
            include = w == this.previewWidth
          }
          if (include && /^(scale_?crop|max_720)/.test(k)) {
            p = imgSizes[k]
            if (this.preloadedImgs.indexOf(p) < 0) {
              imgs[j] = new Image()
              imgs[j].src = p
              this.preloadedImgs.push(p)
              j++
            }
          }
        }
      }
    },
    checkEdited: function (init) {
      var comp = this
      this.$http.get(this.backend + 'jsonstyles/edited')
      .then(function (response) {
        if (response.data) {
          var data = response.data
          if (typeof data === 'object') {
            if (data.nodes) {
              if (data.nodes instanceof Array) {
                this.$ls.set('editednodes', data)
                if (init === true) {
                  var d = comp.$ls.get('sitedata',{})
                  var updateProjects = false
                  var updateHome = false
                  var updateJournal = false
                  var updateNode
                  if (d.nodes) {
                    for (var i =0 ; i < data.nodes.length; i++) {
                      var it = data.nodes[i]
                      var pi = _.findIndex(d.nodes, function(n) { return n.nid == it.nid; });
                      var sect = it.alias.replace(/^\//,'').split('/').shift();
                      updateNode = false
                      if (pi > -1) {
                        if (it.changed > d.nodes[pi].changed) {
                          updateNode = true
                        }
                      } else {
                        updateNode = true
                      }
                      if (updateNode) {
                        switch(sect) {
                          case 'projects':
                            updateProjects = true
                            break;
                          case 'home':
                            updateHome = true
                            break;
                          case 'journal':
                            updateJournal = true
                            break;
                        }
                      }
                    }
                    if (updateProjects) {
                      comp.$ls.remove('projects-full')
                      comp.$ls.remove('projects-full-more')
                      comp.loadData('projects-full')
                      comp.loadData('projects-full-more')
                    }
                    if (updateHome) {
                      comp.$ls.remove('home')
                      comp.loadData('home')
                    }
                    if (updateJournal) {
                      comp.$ls.remove('journals')
                      comp.loadData('journals')
                    }
                  }
                }
              }
            }
          }
        }
      }, function (response) {})
    },
    calcPageHeight: function () {
      var B = document.body
      var H = document.documentElement
      return Math.max(B.scrollHeight, B.offsetHeight, H.clientHeight, H.scrollHeight, H.offsetHeight)
    },
    handleScroll: function () {
      this.scrollY = scrollY()
      if (this.stopY > 0) {
        if (this.scrollY > (this.prevY + this.stopY) || this.scrollY < (this.prevY - this.stopY)) {
          this.prevStopY = this.prevY
          this.prevY = this.scrollY
          var sdClassIndex = this.containerClasses.indexOf('scrolled-down')
          if (this.scrollY > this.winHeight / 16) {
            if (sdClassIndex < 0) {
              this.addContainerClass('scrolled-down')
              this.$emit('scrolled-down', true)
            }
          } else {
            if (sdClassIndex >= 0) {
              this.removeContainerClass('scrolled-down')
            }
          }
        }
      }
    },
    handleResize: function (init) {
      var max = 1600
      this.pageHeight = this.calcPageHeight()
      this.winHeight = window.innerHeight
      this.winWidth = winWidth()
      this.maxWidth = this.winWidth > max? max : this.winWidth 
      this.touchActive = (this.winWidth < 1080 && this.touchEnabled)
      if (init === true) {
        this.stopY = this.winHeight / 64
        this.halfWY = this.winHeight / 2
      }
    },
    handleKeys: function (e) {
      switch (e.keyCode) {
        case 27:
        case 37:
        case 39:
          var path = this.$route.path
          var isProject = /\/projects\/\w+/.test(path)
          break;
      }
      switch (e.keyCode) {
        case 27:
          if (isProject) {
            this.$router.push('/projects')
          }
          if (this.showAdmin) {
            this.showAdmin = false
          }
          break
        case 37:
         if (path === '/home') {
            this.$emit('nav-screen', 'prev')
          } else {
            window.history.back()
          }
          break
        case 39:
          if (path === '/home') {
             this.$emit('nav-screen', 'next')
          } else if (isProject) {
            this.$emit('show-next-project', true)
          } else {
             window.history.forward()
          }
          break
      }
    },
    menuToggle: function () {
      var index = this.containerClasses.indexOf('show-menu')
      if (index < 0) {
        this.containerClasses.push('show-menu')
      } else {
        this.containerClasses.splice(index, 1)
      }
    },
    clearLocalStorage: function () {
      var ts = Math.floor(new Date().getTime() / 1000)
      if ((ts - 60) > this.clearTs) {
        this.$ls.clear()
        this.clearTs = ts
        this.allProjectsLoaded = false
        this.checkSiteInfo()
      }
    },
    addContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'add')
    },
    removeContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'rem')
    },
    toggleContainerClass: function (clsName, mode) {
      var index = this.containerClasses.indexOf(clsName)
      if (mode === 'add' && index < 0) {
        this.containerClasses.push(clsName)
      } else if (index >= 0) {
        switch (mode) {
          case 'rem':
          case 'remove':
            this.containerClasses.splice(index, 1)
            break
        }
      }
    },
    closeAdmin: function () {
      this.adminUrl = ''
      this.checkEdited()
    },
    scrollTo: function (offsetY, reset) {
      if (this.scrolling === false) {
        this.scrolling = true
        var comp = this
        this.$scrollTo('body', 250, {
          offset: offsetY,
          easing: 'ease-in',
          cancelable: false,
          onDone: function () {
            comp.scrolling = false
          },
          onCancel: false
        })
        if (!reset) {
          reset = 1000
        }
        setTimeout(function () {
          comp.scrolling = false
        }, reset)
      }
    },
    showNext: function() {
      this.$emit('show-next-project', true)
    },
    clearCaches: function() {
      this.$ls.clear()
      this.checkSiteInfo()
      this.showStatus("All local caches cleared")
    },
    showStatus: function(msg) {
      this.statusMsg = msg
      this.showStatusMsg = true
      var comp = this
      setTimeout(function() {
        comp.showStatusMsg = false
      }, 5000)
      setTimeout(function() {
        comp.statusMsg = ''
      }, 7000)
    }
  }
}
</script>

<style>
body {
  font-family: Raleway, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: white;
}


html {
  font-size: 14px;
}


#top-header a,
body {
  /* color: #422314; */
  color: #3c3c3c;
}

#app a {
  text-decoration: none;
}

#app .loader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  z-index: -1;
  transition: opacity 750ms ease-in-out;
}

#app.loading .loader {
  background-image: url(/static/images/oval.svg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 8%;
  opacity: 1;
  z-index: 2;

}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

#app .seo-content {
  animation: fadein 4s 1;
}

.journal-container > .content-title,
.projects .content-title,
.alt-text {
  display: inline-block;
  position: absolute;
  left:  -9999em;
  top:  0;
}

#site-logo {
  position: absolute;
  top:  -1.5em;
  left:  1.25%;
  margin: 0;
  padding: 0;
  height:  2em;
  width:  60%;
  background-image: url(/static/images/logo.svg);
  background-repeat: no-repeat;
  background-position: top left;
  background-size: contain;
  pointer-events: all;
}

#site-logo a {
  display: block;
  width:  100%;
  height: 100%;
}

blockquote,
figure, ul, ol, picture {
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
  -webkit-padding-start: 0;
  padding-inline-start: 0;
  margin-inline-start: 0;
}

figure, picture {
  margin: 0;
}

article ol,
article ul {
  padding-left:  1.5em;
}

.listing,
.listing li,
.menu,
.horizontal,
.horizontal li,
.menu li {
  list-style-type: none;
  margin:  0;
}

.slide-filter li,
#top-header .menu li {
  position: relative;
}

#top-header .menu li {
  position: relative;
  padding: 0 0.25em 0 1.75em;
}

.slide-filter li {
  padding: 0 0.5em 0 1em;
}

.projects-list li,
.slide-filter li {
  cursor: pointer;
}

#app .slide-filter li:first-child {
  padding-left: 0;
}

.content-container a,
#app .slide-filter li.active,
ul.projects-list li figcaption .inner:before,
.journal-entry h4,
#app h2.article-title,
.journal-entry time {
  color: #C4B32F;
}

#app .carousel .arrow:hover,
#app .slide-container .arrow:hover {
  color:  white;
  opacity: 1;
}

article.work h2,
article.work h5,
.journal-entry h4 {
  font-size: 1em;
  font-weight: normal;
}

article.work h2 {
  margin: 1em 0;
}

article.node-page > h2.show-title {
  font-size: 1em;
  margin-top: 0;
  padding-top: 0;
}

article.node-page > h2.hide-title {
  position: absolute;
  top:  0;
  left: -9999em;
}

article.work h5,
.journal-entry h4 {
  font-weight: normal;
  margin: 0 0 1em 0;
}

article .info {
  font-size: 0.9em;
  color: #C4B32F;
}

article.work h5 {
  margin: 0;
}

#top-header .project-arrow {
  position: absolute;
  top: 0.125em;
  width: 2em;
  min-height: 1.75em;
  cursor: pointer;
  color: #C4B32F;
  z-index:  100;
  pointer-events: all;
}
#top-header .project-arrow:hover {
  color: black;
}

#top-header .project-arrow:before {
  font-size: 1em;}

/* article.work .icon-triangle-prev {
  right: 5em;
} */

#top-header .icon-triangle-next {
  right:  2.5%;
}

#app.touch-enabled .click-overlay,
.touch-overlay {
  display:  none;
}

.click-overlay,
#app.touch-enabled .touch-overlay {
  display: block;
}

.projects .slide-filter {
  margin-top: 1em;
  margin-bottom: 1.125em;
  padding-top: 0.875em;
  text-align: left;
  text-transform: lowercase;
}

.bullets li {
  cursor: pointer;
}

.horizontal li {
  display: inline-block;
}

#top-header .menu li {
  text-transform: lowercase;
}

#top-header .menu {
  float:  right;
}

#top-header a {
  text-decoration: none;
}

#footer a:hover,
#top-header a:hover {
  color: black;
}

.bullets li:before,
#top-header .menu li:before {
  position: absolute;
  font-family: icomoon;
  top: 0.3em;
  left:  0.6em;
  content: "\e904";
  font-size: 0.75em;
  color: #C4B32F;
}



.home > h2 {
  position: absolute;
  left:  -9999em;
}

#admin-bar,
.fixed-container {
  position: fixed;
  top:  2em;
  right:  1.25%;
}

.has-overlay #admin-bar {
  display: none;
}

#admin-bar {
  z-index:  150;
}

.inner .icon-cancel:before {
  font-size: 2em;
}

.horizontal li {
  display: inline-block;
}

.menu-toggle:before,
.menu-toggle {
  position: absolute;
}

.menu-toggle {
  top: 0.5em;
  right: 2.5%;
  cursor: pointer;
  color: #a3948d;
  transition: color .25s ease-in-out;
}

.show-menu .menu-toggle:hover,
.menu-toggle:hover {
  color:  black;
}

.show-menu .menu-toggle {
  color: #C4B32F;
}

.menu-toggle:before {
  top:  0;
  right:  0;
  font-size: 2em;
}

.menu-toggle > span {
  font-size: 1.25em;
  opacity: 0;
}

.section {
  clear:  both;
}

.pictures.half-landscape,
.pictures.half-portrait,
.pictures.half,
.section .pictures,
.section .pictures figure,
.section .pictures picture,
.section .pictures img {
  position: relative;
  width:  100%;
}

.pictures img {
  margin:  0 0 1em 0;
}

.pictures figure:last-child img {
  margin:  0;
}

.section .pictures figcaption {
  position: relative;
  width:  100%;
  padding: 0.25em 0 1.5em 0;
  text-align: center;
  font-size: 0.8em;
}

.section .subtitle {
  clear: both;
}

@media screen and (max-width: 767px) {
  #top-header .horizontal li {
    display: block;
    margin: 1.25em 0;
    text-align: left;
    font-size: 1.125em;
  }

  @media (max-height: 300px) {
    #top-header .horizontal li {
      margin: .75em 0;
      font-size: 1em;
    }
  }

   @media (min-height: 301px) and (max-height: 400px) {
    #top-header .horizontal li {
      margin: .9em 0;
      font-size: 1em;
    }
  }

  #top-header > .inner > ul {
    margin-top: 3em;
    float:  none;
  }

  .show-menu #top-header > .inner {
    background-color:  white;
  }
  .show-menu #top-header {
    z-index: 60;
  }
}

#admin-bar > span,
nav li {
  cursor: pointer;
}

ul.projects-list li,
ul.projects-list li figure {
  position: relative;
}


ul.projects-list li figcaption {
  position: absolute;
  display:  flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  left:  0;
  right:  0;
  top: 0;
  bottom: 0;
  background: white;
  opacity: 0;
  transition: opacity 500ms ease-in-out;
}

ul.projects-list li figcaption .inner {
  overflow: hidden;
  padding: 1em 0;
  position: relative;
}

ul.projects-list li figcaption .inner:before,
ul.projects-list li figcaption .inner:after {
  font-family: icomoon;
  position: absolute;
}

ul.projects-list li figcaption .inner:before {
  top: 0;
  left:  0;
  content:  " ";
}

/* ul.projects-list li figcaption .inner:after {
  bottom: 0;
  right:  12.5%;
  content:  "\ea2e";
} */

ul.projects-list li figcaption .inner h4 {
  font-weight: normal;
  padding: 0;
  margin: 0;
  font-size: 0.875em;
}

ul.projects-list li figcaption {
    top: 0;
}

ul.projects-list li.tapped figcaption,
ul.projects-list li:hover figcaption {
    opacity: 1;
}

ul.projects-list li {
  position: relative;
  padding: 0;
  margin: 0 0 3vw 0;
}

ul.projects-list li:hover figcaption {

}

ul.projects-list {
  display: flex;
  flex-flow: row wrap;
}

picture img,
figure img {
  max-width:  100%;
  height:  auto;
}

.show-detail .detail-content,
.show-listing .main-content {
  position: relative;
  opacity: 1;
  z-index: 4;
}

.show-detail .main-content,
.show-listing .detail-content {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index:  -1;
  pointer-events: none;
  max-height: 100vh;
  overflow: hidden;
}

#top-header {
  position: fixed;
  top:  0;
  left:  0;
  right:  0;
  height:  4em;
  z-index:  20;
  background-color: white;
}

header nav.inner {
  pointer-events: none;
}

header nav.inner ul.menu {
  position: relative;
  opacity: 0;
  padding-top: 1.5em;
  transition: max-height 375ms ease-in-out, opacity 125ms ease-in-out 250ms;
  pointer-events: none;
  max-height:  0;
  overflow: hidden;
}

.show-menu header nav.inner ul.menu {
  opacity: 1;
  pointer-events: all;
  max-height:  100vh;
  transition: opacity 125ms ease-in-out, max-height 375ms ease-in-out 50ms;
}


.node-page,
.detail-content,
.content-container article,
.body {
  text-align: left;
}

.sections .section {
  position: relative;
  margin-bottom: 1em;
}

.sections .section > .text,
article > .body {
  max-width: 60em;
}

.sections .quote > blockquote.text {
  padding: 0 2em;
  max-width: 56em;
}

.sections .quote > h4.author {
  padding: 0 3em;
  margin: 0.5em 0 1em 0;
}

.body,
article > h2 {
  color:  black;
}

.content-container {
  transition: opacity 0.25s ease-in-out;
  opacity: 1;
}

/* .loading .content-container {
  opacity:  0.9;
} */

.overlay-container #admin-frame,
#app,
#top-header > .inner {
  position: relative;
  margin:  0 auto;
  padding: 0 2.5% 2em 2.5%;
  max-width: 1524px;
}

.overlay-container > .close {
  position: fixed;
  top: 1rem;
  font-size: 2.5em;
  right: 0.5%;
  width:  1em;
  cursor: pointer;
  z-index: 300;
  pointer-events: all;
}

.overlay-container {
  position: fixed;
  pointer-events: none;
  top:  0;
  bottom: 0;
  left:  0;
  right:  0;
}

#admin-frame {
  border: none;
  width:  96%;
  min-height: 100vh;
  opacity: 0;
  z-index:  -1;
  background-color:  white;
  transition: opacity 0.5s ease-in-out;
}

#app .show-admin,
.show-admin #admin-frame {
  opacity: 1;
  z-index:  290;
  pointer-events: all;
}

.content-container {
  position: relative;
  margin:  5em 0 0 0;
  min-height: 70vh;
}

.slide-container nav ol {
  margin-top: 0.5em;
}

.carousel > .arrow,
.slide-container > .arrow {
  position: absolute;
  top:  0;
  bottom: 2em;
  width:  25%;
  transition: opacity 250ms ease-in-out;
  opacity: 0;
  color:  white;
}

.carousel:hover .arrow,
.slide-container:hover .arrow {
  opacity: 0.8;
  z-index: 19;
}

.carousel .arrow:before,
.slide-container .arrow:before {
  position: absolute;
  top: 50%;
  font-size: 2em;
  cursor: pointer;
  opacity: 0.6667;
  transition: opacity .25s ease-in-out;
}

.detail-content .swipe-back {
  position: absolute;
  top:  0;
  left:  30%;
  right:  30%;
  height: 15vh;
  max-height: 30vw;
  z-index: 120;
}

.slide-container .arrow:before {
  margin: -.5em .25em 0 .25em;
}

#app article.content-container {
  padding: 0.75em 0;
}
.carousel .arrow:before {
   margin: -1em .25em 0 0.25em;
}

.carousel .next:before,
.carousel > .next,
.slide-container .next:before,
.slide-container > .next {
  right: 0;
}

.carousel .prev:before,
.carousel > .prev,
.slide-container .prev:before,
.slide-container > .prev {
  left: 0;
}

.carousel nav ol li,
.slide-container nav ol li {
  text-indent: -10em;
  font-size: 0.5625em;
  width: 1em;
  height: 1em;
  overflow: hidden;
  background-color: #a3948d;
  border-radius: 1em;
  margin: 0 .6666em 0 0.333em;
}

.carousel nav,
.slide-container nav {
  position: relative;
  text-align: left;
  padding-left: 25%;
}

.slide-container nav {
  left:  2.5%;
}

/* .carousel nav {
  text-align:  center;
  margin:  1em auto 0.5em auto;
} */

.carousel nav ol li.active,
.slide-container nav ol li.active {
  background-color: #C4B32F;
}

.slide-container .slides li,
.slide-container .slides {
  overflow: hidden;
  margin:  0;
}


.slide-container .slides li {
  height:  100%;
  padding:  0;
  pointer-events: none;
  z-index: -1;
  height: 100%;
  max-height: 100%;
}

article .slide-container .slides {
  position: relative;
  height:  56.25vw;
  max-height: 100%;
  width:  100%;
  padding: 0;
}

@media screen and (max-width: 640px) and (min-height: 400px) {
  article .slide-container .slides {
    height:  133.33vw;
  }
}

.slide-container {
  position: relative;
  width:  105%;
  margin: 0 -2.5%;
  top:  -0.5em;
}



.slide-container .slides li {
  position: absolute;
  top:  0;
  bottom: 0;
  left:  0;
  right: 0;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

#app .embed .playing .overlay {
  opacity: 0;
  pointer-events: none;
}

#app .embed .playing iframe {
  opacity: 1;
  pointer-events: all;
}

.embed .overlay {
  opacity: 1;
}

.embed .overlay,
.embed iframe {
  transition: opacity 0.5s ease-in-out;
}

.embed,
.embed .overlay,
.embed .overlay img,
.embed iframe {
  width:  100%;
}

.embed .overlay img {
  height: auto;
}

.embed .player {
  position: relative;
}

.embed .player iframe {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  left:  0;
  right: 0;
  bottom:  0;
  height: 100%;
}

.journal-entry,
.journal-entry > .float-first {
  clear:  both;
}

#footer {
  clear:  both;
  margin: 3em auto 2em auto;
  font-size: 0.8em;
}

#footer,
#footer a {
  color: #422314;
}

#footer > ul {
  text-align: left;
  padding-left: 0;
}

#footer > ul.bottom-list li {
  margin-right:  0.5em;
  padding-right:  0.5em;
  border-right:  solid 1px #422314;
}

#footer > ul.bottom-list li:last-child {
  border-right:  none;
}

#footer li {
  cursor:  pointer;
}

#footer .status-msg {
  padding: 1em 0;
  text-align: center;
  margin: 0.5em auto;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

#footer .status-msg.show {
  opacity: 1;
}

.slide-container .slides li.active {
  opacity: 1;
  pointer-events: all;
  z-index: 3;
  cursor: pointer;
}

.carousel,
.top-carousel {
  position: relative;
}

.carousel {
  margin: 0;
  width:  100%;
}

.top-carousel {
  min-height: 42.5vw;
}

.top-carousel > figure {
  position: absolute;
  top:  0;
  bottom:  0;
  opacity:  0;
  height: 100%;
  display: flex;
  width:  100%;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  z-index:  -2;
  transition: opacity .5s ease-in-out;
}

.top-carousel > figure figcaption {
  position: absolute;
  bottom:  2.5vh;
  opacity: 0;
  padding: 0.625em 1em;
  text-align: center;
  transition: opacity .5s ease-in-out;
}

.top-carousel > figure.active figcaption:hover {
  opacity: 1;
  background-color: rgba(255,255,255,.5);
}

.top-carousel figure picture {
  position: relative;
  height: 100%;
}

@media screen and (max-width:640px) and (min-height: 400px) {
  #app .top-carousel {
    min-height:  133.33vw;
  }
}

.slide-container .slides li img,
.top-carousel > figure img {
  width:  100%;
  height:  auto;
  /* max-height: 100%; */
}

.carousel .top-carousel.num-images-1 > figure,
.top-carousel > figure.active {
  opacity: 1;
  z-index:  3;
}

.core-content .date,
.core-content .body {
  font-size:  0.9em;
}

article .body p {
  line-height: 1.5em;
}

/* @media screen and (min-width: 480px) {
  .carousel nav,
  .slide-container nav {
    padding-left: 7.125em;
  }
} */

@media screen and (min-width: 640px) {
  ul.projects-list li {
    width:  50%;
    margin-bottom: 4vw;
  }
  ul.projects-list li img {
    min-height: 34vw;
  }
  ul.projects-list li figure {
    margin: 0 9% 0 0;
  }

  #app ul.projects-list {
    width:  104.5%;
  }

  .section .pictures.half figure {
    width:  49.625%;
    float:  left;
  }

  .sections .section .half-mixed-2 figure.fig-1,
  .sections .section .half-mixed figure.fig-0 {
    width:  64.75%;
  }

  .sections .section .half-mixed-2 figure.fig-0,
  .sections .section .half-mixed figure.fig-1 {
    width:  35.25%;
  }

  .sections .section .half-mixed-2 figure.fig-1 img,
  .sections .section .half-mixed figure.fig-1 img {
    float:  right;
  }
  .sections .section .half-mixed figure.fig-1 img {
    margin-right: 5%;
  }

  .sections .section .half-mixed-2 figure.fig-1 img {
    margin-left: 2%;
    margin-right: 2.5%;
  }

  .section .pictures.half img {
    display: block;
    margin: 0 2% 1.95vw 0;
    width:  96%;
  }

    /* .sections .section .half-portrait img {
      width:  75%;
    } */

  .sections .section .pictures .index-1 img {
    float:  right;
  }
  .carousel nav,
  .slide-container nav {
    padding-left: 7.125em;
  }
}

@media screen and (min-width: 640px) {
  #app .slide-container .slides li,
  #app article .slide-container .slides {
    height: 45vw;
    max-height: 720px;
  }
}

@media screen and (min-width: 768px) {
  #top-header nav.inner ul.menu {
    opacity: 1;
    pointer-events: all;
    max-height: none;
    padding-top: 0;
  }

  #top-header .project-arrow {
    top: 3.25em;
  }

  #top-header .project-arrow:before {
    font-size: 1.25em;
  }

  .detail-content .swipe-back {
    max-height: 15vw;
  }

  #top-header .menu-toggle {
    display: none;
  }
  #top-header .menu li.item-0:before {
    content: "";
  }
  #top-header {
    height: 8.25em;
  }

  #top-header .menu {
    margin-top: 5.75em;
  }

  #top-header .menu li {
    padding: 0.45em 0.25em 0.5em 1.75em;
  }

  #top-header .menu li:before {
    top: 1em;
  }

  #app .content-container {
    margin-top: 8.375em;
  }

  .slide-container {
    top: -1em;
  }

  .carousel nav,
  .slide-container nav {
    padding-left: 12.625em;
    margin-top: 1em;
    margin-bottom: 1.875em;
  }

  .carousel nav ol,
  .slide-container nav ol {
    position: relative;
    height:  1em;
    top:  -0.125em;
    margin-top: 0;
    padding-top: 0;
  }

  .carousel nav ol {
     top:  -0.125em;
  }
  .slide-container nav ol {
    top:  0;
  }

  #site-logo {
    left:  0.625%;
  }
  .journal-entry > .half-width {
    max-width:  48.75%;
  }

  .section .pictures.half-landscape,
  .section .pictures.half-portrait,
  .section .pictures.half {
    width:  102%;
  }

  .section .pictures img {
    margin:  0;
  }

  .journal-entry > .float-first {
    float:  left;
    padding: 0 1.25% 2em 0;
    margin: 0 -1% 0 0;
  }

  .journal-entry > .float-second {
    float:  right;
    padding: 0 0 2.25em 1.25%;
  }
  .core-content > h4.blog-title {
    margin-top: 0;
    padding-top: 0;
  }
  #site-logo {
    top:  1.2em;
    left:  1.25%;
    padding: 0;
    height: 3em;
    width:  10em;
  }
  #footer > ul {
    padding-left: 52%;
  }
}

@media screen and (min-width: 960px) {
  ul.projects-list li {
    width:  33.3333%;
    margin-bottom: 2.5vw;
  }

  #footer > ul {
    padding-left: 34.33%;
  }

  #app ul.projects-list {
    width:  103%;
  }
  ul.projects-list li img {
    min-height: 22.667vw;
  }
}

@media screen and (min-width:1080px) {
  #app .detail-content .swipe-back {
    display:none;
    z-index: -1;
  }
  #app article.content-container .main-image {
    float:  left;
    max-width:  48%;
    margin: 0 2% 0 0;
  }

  #app article.content-container > .body  {
    float:  left;
    max-width:  48%;
    margin: 0 0 0 2%;
  }
  #top-header > .inner #site-logo {
    left: 1.5%;
  }
}

@media screen and (min-width: 1200px) {
  ul.projects-list li {
    width:  25%;
    margin-bottom: 1.8vw;
  }
  #app ul.projects-list {
    width:  102.25%;
  }
  ul.projects-list li img {
    min-height: 17vw;
  }
  #footer > ul {
    padding-left: 25.667%;
  }
  #top-header > .inner #site-logo {
    left: 1.6%;
  }
}

@media screen and (min-width: 1300px) {
  html {
    font-size: 15px;
  }
}

@media screen and (min-width: 1400px) {
  #top-header > .inner #site-logo {
    left: 1.7%;
  }
}

@media screen and (min-width: 1500px) {
  html {
    font-size: 16px;
  }
}

@media screen and (min-width: 1600px) {
  ul.projects-list li {
    margin-bottom: 32px;
  }
  ul.projects-list li img {
    min-height: 264px;
  }
  #site-logo {
    left:  1.25%;
  }
  .top-carousel,
  article .slide-container .slides {
    height:  720px;
    min-height:  720px;
  }

  #top-header > .inner #site-logo {
    left: 1.8%;
  }

  /*#top-header .inner {
    margin-left: auto;
    left: calc(0.75% - 0.18em);
  }*/
  /*#top-header nav.inner ul.menu {
    margin-right: calc(0.75% - 0.18em);
  }*/
  .slide-container nav {
    margin-top:  0.875em;
  }
  section .pictures.half img {
    margin-bottom: 31px;
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?0c8bf930